export default function countReduce(num: number) {
  /**
   * converts numbers to their biggest possible denominations: eg 10000 -> 10 K, 23000 -> 23 K
   * @param {number} num
   */
  if (num < 1000) {
    return num.toString();
  } else if (num < 1000000) {
    // Thousands (K)
    const value = num / 1000;
    // If it's a whole number, don't show decimal
    if (value % 1 === 0) {
      return `${value} K`;
    }
    // Otherwise show one decimal place
    return `${value.toFixed(1)} K`;
  } else if (num < 1000000000) {
    // Millions (M)
    const value = num / 1000000;
    if (value % 1 === 0) {
      return `${value} M`;
    }
    return `${value.toFixed(1)} M`;
  } else {
    // Billions (B)
    const value = num / 1000000000;
    if (value % 1 === 0) {
      return `${value} B`;
    }
    return `${value.toFixed(1)} B`;
  }
}
